import { Int } from './src/Int';
import { FixedInt } from './src/FixedInt';
import { FixedFloat } from './src/FixedFloat';
import { ArrayOf } from './src/ArrayOf';
import { Bitmap } from './src/Bitmap';
import { Buffer } from './src/Buffer';
import { Packet } from './src/Packet';
import { BinaryString } from './src/BinaryString';
import { Date } from './src/Date';
import { Enum } from './src/Enum';
import { HexColor } from './src/HexColor';
import { ObjectId } from './src/ObjectId';
import { UnsafeString } from './src/UnsafeString';
import { Json } from './src/Json';
export var Binary = {
    ArrayOf: ArrayOf,
    BinaryString: BinaryString,
    Bitmap: Bitmap,
    Buffer: Buffer,
    Date: Date,
    Enum: Enum,
    FixedFloat: FixedFloat,
    FixedInt: FixedInt,
    HexColor: HexColor,
    Int: Int,
    ObjectId: ObjectId,
    UnsafeString: UnsafeString,
    Packet: Packet,
    Json: Json,
};
